import React from "react";
import { ConfirmDialogShell, SecondaryButton, DangerButton, GLYPH } from "./v2";

// Delete-list confirm (frames 1p desktop / 1q mobile — V2 rebuild, 1:1 from the
// artboard, R3). The players in the list move to My Radar with notes/labels/
// statuses kept; the action can't be undone. Destructive → creator/ClubAdmin
// only (gated upstream). Copy per artboard: desktop keeps "their", the mobile
// sheet drops it (intentional shorter variant); real list name + count, never
// baked samples. Same onCancel/onConfirm handlers as before the rebuild.
const ClubDeleteListModal = ({ listName, count = 0, mobile, onCancel, onConfirm }) => {
  const players = `${count} player${count === 1 ? "" : "s"}`;
  const myRadar = <span style={{ fontWeight: 700, color: "#374151" }}>My Radar</span>;
  const title = (
    <>Delete {GLYPH.quoteOpen}{listName}{GLYPH.quoteClose}?</>
  );
  const body = mobile ? (
    <>The {players} in this list move to {myRadar}: notes, labels and statuses are kept. This can{GLYPH.apostrophe}t be undone.</>
  ) : (
    <>The {players} in this list move to {myRadar}: their notes, labels and statuses are kept. This can{GLYPH.apostrophe}t be undone.</>
  );
  const actions = mobile ? (
    <>
      <DangerButton height={46} radius={12} fontSize={14} style={{ width: "100%" }} onClick={onConfirm}>
        Delete list
      </DangerButton>
      <SecondaryButton height={42} radius={12} fontSize={13} style={{ width: "100%" }} onClick={onCancel}>
        Cancel
      </SecondaryButton>
    </>
  ) : (
    <>
      <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
      <DangerButton onClick={onConfirm}>Delete list</DangerButton>
    </>
  );
  return (
    <ConfirmDialogShell open mobile={mobile} onClose={onCancel} title={title} body={body} actions={actions} />
  );
};

export default ClubDeleteListModal;
